module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat4-cfbe1edf931cb6dbd1bbc8f964bcb6a0.jpg";